import{gql as e}from"@apollo/client";const n=e`
  query getAnswers($userFlowStepTrackId: Int!) {
    questionAnswer {
      getAnswers(trackingId: $userFlowStepTrackId) {
        id
        contentSnippetQuestionId
        ... on QuestionAnswerCalendarType {
          dateAnswered
        }
        ... on QuestionAnswerCheckboxType {
          selectedAnswers {
            questionResponseCheckboxId
          }
        }
        ... on QuestionAnswerDropDownListType {
          questionResponseDropDownListId
        }
        ... on QuestionAnswerMultilineTextType {
          text
        }
        ... on QuestionAnswerMultiResponseTextType {
          responses {
            value
          }
        }
        ... on QuestionAnswerNumberType {
          numberAnswered
        }
        ... on QuestionAnswerRadioType {
          questionResponseRadioId
        }
        ... on QuestionAnswerSinglelineTextType {
          text
        }
        ... on QuestionAnswerSliderType {
          value
        }
      }
    }
  }
`;export{n as GET_ANSWERS_QUERY};
//# sourceMappingURL=useGetAnswers.graphql.js.map
